<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>公司资料</span></p>
      <div class="personal-box">
        <Menu></Menu>
        <div class="MainInfo">
        
          <div class="infoContext">
            <div class="list-for" v-for="item,index in vsData" :key="index">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <img :src="item.firstFile.FileUrl" alt="">
                <div class="list-item">
                  <p class="title">{{ item.name }}</p>
                  <div class="item-info">
                      <p class="item-text">
                        <span class="info-title">ID</span>
                        <span>{{ item.id }}</span>
                      </p>
                      <p class="item-text">
                        <span class="info-title">姓名</span>
                        <span>{{ item.contact }}</span>
                      </p>
                      <p class="item-text">
                        <span class="info-title">手机</span>
                        <span>{{ item.phone }}</span>
                      </p>
                  </div>
                </div>
              </div>
              <div style="text-align: right;">
                <el-button :type="
                    item.audit_status == '1'?'success':
                    item.audit_status == '2'?'error':
                    (item.audit_status == '0' || item.audit_status == '100')?'primary': ''
                  " 
                  plain round disabled size="small">
                  {{ item.audit_status == '1' ? '审核通过':item.audit_status == '2' ? '审核不通过' : (item.audit_status == '0' || item.audit_status == '100') ? '审核中' : '' }}
                </el-button>
                <el-button round  size="small" @click="getCompanyInfo(item.id)">详情</el-button>                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </template>
  
  <script>
  import Menu from '../../personal/index.vue'
  export default{
    data(){
      return{
        userInfo: {},
        loginIs: true,
        vsData: []
      }
    },
    components:{
      Menu
    },
    methods: {
  
      getCompanyInfo(id){
        this.$router.push({
          path: '/companyDetail',
          query: {
            key: id,
            currentName: '公司详情'
          }
        })
      }
     
    },
    mounted(){
      let data = {
        pageNum: 1,
        pageSize: 99999,
      }
      this.$store.dispatch('join/companyList',data)
        .then(res => {
          if(res.ok){
            var dpn = res.data.items.length
            if(dpn > 0){
              this.vsData = res.data.items
            }
          }
        })
    
    }
  }
  </script>
  
  <style scoped lang="scss">
  @import url('@/css/personal.css');
 
  .infoContext{
    .list-for{
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid #f2f2f2;
      img{
        // border: 0.5px solid #f2f2f2;
        width: 150px;height: 100px;
        object-fit: cover;
      }
      .list-item{
        width: calc(100% - 170px);
        height: 100px;
        .title{
          width: 100%;
          font-size: 18px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          
        }
      }
    }
  }
  .item-info{
    margin-top: 15px;      
   .item-text{
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #464545;
      .info-title{
        color: #999999;
        margin-right: 10px;
      }
    }
  }
 
  
  </style>